import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";

type CtaBandProps = {
  eyebrow?: string;
  title?: string;
  body?: string;
  buttonLabel?: string;
  href?: string;
};

/**
 * Standardised closing CTA band used across every sub-page so the
 * site has a consistent rhythm matching the SEO theme demo.
 */
export function CtaBand({
  eyebrow = "Let's talk",
  title = "Want better enquiries from your website?",
  body = "Tell me about your business and your goals. I'll come back with a clear view on what's worth doing first.",
  buttonLabel = "Start a conversation",
  href = "/contact",
}: CtaBandProps) {
  return (
    <section className="demo-cta-band container mx-auto max-w-7xl px-6 pt-12 pb-20 lg:px-10 lg:pt-16 lg:pb-24">
      <div className="relative overflow-hidden rounded-[10px] border border-primary/40 bg-card p-10 text-foreground shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] lg:p-16">
        <div className="relative max-w-2xl">
          {eyebrow && <p className="demo-section-label">{eyebrow}</p>}
          <h2 className="site-heading-lg mt-4 font-display font-light">{title}</h2>
          <p className="site-copy mt-5 text-muted-foreground">{body}</p>
          <Link
            to={href}
            className="mt-8 inline-flex items-center gap-3 demo-button-primary rounded-full px-7 py-4 text-sm font-semibold transition-transform hover:-translate-y-0.5"
          >
            {buttonLabel}
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}